(function () {
	// ---- MARKERS ----
	const ID_ONLY = "[A-Za-z0-9_-]{1,64}";
	const TAB_STRICT = new RegExp(
		'^"?\\[\\s*(?:tab\\s*:\\s*([^\\]]+?)|(' + ID_ONLY + '))\\s*\\]"?$',
		"i"
	);
	const CT_STRICT = new RegExp(
		'^"?\\[\\s*(?:content(?:\\s*:\\s*([^\\]]+?))?|(' + ID_ONLY + '))\\s*\\]"?$',
		"i"
	);
	// Loose: bất kỳ nội dung trong []
	const BRACKET_FULL_LINE = /^"?\[\s*([\s\S]*?)\s*\]"?$/;

	// ---- HELPERS ----
	function splitParagraphToLinesHTML(pEl) {
		const normalized = pEl.innerHTML.replace(/<br\s*\/?>/gi, "\n");
		return normalized.split("\n").map((s) => s.trim());
	}
	function htmlToText(html) {
		const tmp = document.createElement("div");
		tmp.innerHTML = html;
		return (tmp.textContent || tmp.innerText || "").trim();
	}
	function stripBracketWrapperHTML(htmlLine) {
		// Bỏ [ ] bọc ngoài nhưng GIỮ nguyên anchor/thẻ bên trong
		return htmlLine.replace(/^\s*"?\[\s*/, "").replace(/\s*\]"?\s*$/, "");
	}
	function enhanceLinksIn(el) {
		// Đặt target/rel và (option) underline cho link trong summary
		el.querySelectorAll("a[href]").forEach((a) => {
			a.target = "_blank";
			a.rel = "noopener";
		});
	}
	function escapeHtml(str) {
		return String(str)
			.replaceAll("&", "&amp;")
			.replaceAll("<", "&lt;")
			.replaceAll(">", "&gt;")
			.replaceAll('"', "&quot;")
			.replaceAll("'", "&#039;");
	}

	function makeDetails(titleHTML, subtitleText, contentHTML) {
		const details = document.createElement("details");
		details.className = "donation-acc";

		const summary = document.createElement("summary");
		summary.className = "donation-acc__title";
		summary.innerHTML = titleHTML; // GIỮ nguyên HTML đã strip [ ]
		enhanceLinksIn(summary); // link chỉ ở phần được bọc <a>
		details.appendChild(summary);

		if (subtitleText && String(subtitleText).trim()) {
			const sub = document.createElement("div");
			sub.className = "donation-acc__subtitle";
			sub.textContent = String(subtitleText).trim();
			details.appendChild(sub);
		}

		const body = document.createElement("div");
		body.className = "donation-acc__content";
		if (contentHTML && contentHTML.trim()) {
			const wrap = document.createElement("div");
			wrap.innerHTML = `<p>${contentHTML}</p>`; // giữ <br> mềm
			Array.from(wrap.childNodes).forEach((n) => body.appendChild(n));
		}
		details.appendChild(body);
		return details;
	}

	// ---- PASS 1: nhiều block trong 1 <p> ----
	function preSplitMultiBlocksInParagraphs(root) {
		const paras = Array.from(root.querySelectorAll(":scope > p"));
		paras.forEach((p) => {
			const linesHTML = splitParagraphToLinesHTML(p);
			let i = 0;
			const replacement = [];
			let normalBuf = [];

			const flushNormal = () => {
				if (!normalBuf.length) return;
				const np = document.createElement("p");
				np.innerHTML = normalBuf.join("<br>");
				replacement.push(np);
				normalBuf = [];
			};

			while (i < linesHTML.length) {
				const curHTML = linesHTML[i];
				const nextHTML = linesHTML[i + 1];

				const curText = htmlToText(curHTML);
				const nextText = nextHTML != null ? htmlToText(nextHTML) : "";

				let isPair = false,
					titleHTML = "",
					subtitle = "";
				let jStart = i + 2;

				// Strict pair
				if (TAB_STRICT.test(curText) && CT_STRICT.test(nextText)) {
					const mTab = curText.match(TAB_STRICT);
					const titleText = (mTab[1] || mTab[2] || "").trim();
					titleHTML = stripBracketWrapperHTML(curHTML); // GIỮ link trong dòng tiêu đề
					const mCt = nextText.match(CT_STRICT);
					subtitle = mCt && (mCt[1] || mCt[2]) ? (mCt[1] || mCt[2]).trim() : "";
					isPair = true;
				} else {
					// Loose pair: hai dòng đều là dạng [ ... ]
					const m1 = curText.match(BRACKET_FULL_LINE);
					const m2 = nextText.match(BRACKET_FULL_LINE);
					if (m1 && m2) {
						titleHTML = stripBracketWrapperHTML(curHTML); // giữ nguyên anchor trong tiêu đề
						subtitle = (m2[1] || "").trim();
						isPair = true;
					}
				}

				if (isPair) {
					flushNormal();
					// gom content cho tới trước cặp marker kế tiếp (strict hoặc loose)
					let j = jStart;
					while (j < linesHTML.length) {
						const t = htmlToText(linesHTML[j]);
						const tn = linesHTML[j + 1] != null ? htmlToText(linesHTML[j + 1]) : "";
						const strictNext = TAB_STRICT.test(t) && CT_STRICT.test(tn);
						const looseNext = BRACKET_FULL_LINE.test(t) && BRACKET_FULL_LINE.test(tn);
						if (strictNext || looseNext) break;
						j++;
					}
					const contentHTML = linesHTML.slice(i + 2, j).join("<br>");
					replacement.push(makeDetails(titleHTML, subtitle, contentHTML));
					i = j;
					continue;
				}

				// Không phải marker → giữ nguyên
				normalBuf.push(curHTML);
				i++;
			}

			flushNormal();

			if (
				replacement.length === 1 &&
				replacement[0].tagName === "P" &&
				replacement[0].innerHTML === p.innerHTML
			) {
				return;
			}
			replacement.forEach((node) => p.parentNode.insertBefore(node, p));
			p.remove();
		});
	}

	// ---- PASS 2: ghép cặp giữa 2 <p> liên tiếp ----
	function pairAcrossParagraphs(root) {
		const nodes = Array.from(root.childNodes);
		const frag = document.createDocumentFragment();
		let i = 0;

		while (i < nodes.length) {
			const n = nodes[i],
				next = nodes[i + 1];
			const isP = n?.nodeType === 1 && n.tagName === "P";
			const isNextP = next?.nodeType === 1 && next.tagName === "P";

			if (isP && isNextP) {
				const curText = htmlToText(n.innerHTML);
				const nextText = htmlToText(next.innerHTML);

				let isPair = false,
					titleHTML = "",
					subtitle = "";

				if (TAB_STRICT.test(curText) && CT_STRICT.test(nextText)) {
					titleHTML = stripBracketWrapperHTML(n.innerHTML);
					const mCt = nextText.match(CT_STRICT);
					subtitle = mCt && (mCt[1] || mCt[2]) ? (mCt[1] || mCt[2]).trim() : "";
					isPair = true;
				} else {
					const m1 = curText.match(BRACKET_FULL_LINE);
					const m2 = nextText.match(BRACKET_FULL_LINE);
					if (m1 && m2) {
						titleHTML = stripBracketWrapperHTML(n.innerHTML);
						subtitle = (m2[1] || "").trim();
						isPair = true;
					}
				}

				if (isPair) {
					// gom content tới trước cặp kế tiếp
					const contentNodes = [];
					i += 2;
					while (i < nodes.length) {
						const look = nodes[i],
							lookNext = nodes[i + 1];
						const lookIsP = look?.nodeType === 1 && look.tagName === "P";
						const lookNextIsP = lookNext?.nodeType === 1 && lookNext.tagName === "P";
						if (lookIsP && lookNextIsP) {
							const t = htmlToText(look.innerHTML);
							const tn = htmlToText(lookNext.innerHTML);
							const strictNext = TAB_STRICT.test(t) && CT_STRICT.test(tn);
							const looseNext =
								BRACKET_FULL_LINE.test(t) && BRACKET_FULL_LINE.test(tn);
							if (strictNext || looseNext) break;
						}
						contentNodes.push(look);
						i++;
					}

					const details = document.createElement("details");
					details.className = "donation-acc";

					const summary = document.createElement("summary");
					summary.className = "donation-acc__title";
					summary.innerHTML = stripBracketWrapperHTML(titleHTML); // tiêu đề với link, KHÔNG ngoặc
					enhanceLinksIn(summary);
					details.appendChild(summary);

					if (subtitle) {
						const sub = document.createElement("div");
						sub.className = "donation-acc__subtitle";
						sub.textContent = subtitle;
						details.appendChild(sub);
					}

					const body = document.createElement("div");
					body.className = "donation-acc__content";
					contentNodes.forEach((n2) => body.appendChild(n2));
					details.appendChild(body);

					frag.appendChild(details);
					continue;
				}
			}

			frag.appendChild(n);
			i++;
		}

		root.innerHTML = "";
		root.appendChild(frag);
	}

	function transformRichtextAccordions(root) {
		if (!root) return;
		preSplitMultiBlocksInParagraphs(root);
		pairAcrossParagraphs(root);
	}

	document.addEventListener("DOMContentLoaded", () => {
		document.querySelectorAll(".js-rt-accordion").forEach(transformRichtextAccordions);
	});
	document.addEventListener("shopify:section:load", (e) => {
		e.target.querySelectorAll(".js-rt-accordion").forEach(transformRichtextAccordions);
	});
})();
